import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import '././assets/css/responsive.css';
import ClientApp from './seperateRouter/ClientApp';
import GrapheApp from './seperateRouter/GrapheApp';
import 'primeicons/primeicons.css';
import Home from './pages/defaultpages/Home';
import { AuthProvider } from './context/AuthContext';
import { ClientAuthProvider } from './context/ClientAuthContext';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={ <Home />} />
        {/* Client Routes */}
        <Route path="/Client/*" element={<ClientApp  />} />

        {/* Graphe Routes */}
        <Route path="/Graphe/*" element={<GrapheApp />} />
      </Routes>
    </Router>
  );
}

export default App;  